import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-032-laptop screen",
  "use": "icon-032-laptop screen-usage",
  "viewBox": "0 0 191.132 191.132",
  "content": "<symbol viewBox=\"0 0 191.132 191.132\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-032-laptop screen\"><g><g><g fill=\"#e1e6e9\"><path d=\"m25.642 0-8.763 19.488h17.525z\" /><path d=\"m25.642 191.132-8.763-19.488h17.525z\" /><path d=\"m23.1 13.913h5.084v167.475h-5.084z\" /><path d=\"m25.642 95.12h148.611v5.084h-148.611z\" /></g><path d=\"m32.865 40.626h14.805v54.494h-14.805z\" fill=\"#27a2db\" /><path d=\"m50.123 55.989h14.805v39.154h-14.805z\" fill=\"#44c4a1\" /><path d=\"m67.404 40.626h14.805v54.494h-14.805z\" fill=\"#e56353\" /><path d=\"m84.685 27.269h14.805v67.85h-14.805z\" fill=\"#fcd462\" /><path d=\"m154.073 100.204h14.805v54.494h-14.805z\" fill=\"#27a2db\" /><path d=\"m136.792 100.204h14.805v39.154h-14.805z\" fill=\"#44c4a1\" /><path d=\"m119.534 100.204h14.805v54.494h-14.805z\" fill=\"#e56353\" /><path d=\"m102.255 100.204h14.805v67.85h-14.805z\" fill=\"#fcd462\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/032-laptop screen.svg
// module id = i2oW
// module chunks = 102